import { Flex } from '@chakra-ui/react';
import React from 'react';
import { ClearFiltersButton } from 'src/components/molecules/ClearFiltersButton';
import { FilterAccordion } from 'src/components/molecules/FilterAccordion';
import { LockFiltersButton } from 'src/components/molecules/LockFiltersButton';
import { MasterDataDownloadButton } from 'src/components/molecules/MasterDataDownloadButton';
import { AggregationSelector } from 'src/features/MM/components/molecules/AggregationSelector';
import { DimensionSelector } from 'src/features/MM/components/molecules/DimensionSelector';
import { FilterHeading } from '../../atoms/FilterHeading';
import { BenchmarkSelector } from '../BenchmarkSelector';
import { BenchmarkSelectorError } from '../BenchmarkSelector/BenchmarkSelectorError';
import { TimeRangeSelector } from '../TimeRangeSelector';
import { CampaignsMenu } from '../menus/CampaignsMenu';
import { MediaMenu } from '../menus/MediaMenu';
import { CampaignGroupMenu } from '../menus/CampaignGroupMenu';
import { MenuOpenerButton } from 'src/components/atoms/MenuOpenerButton';
// eslint-disable-next-line no-restricted-imports
import { Icon as ChakraIcon } from '@chakra-ui/react';
import { Calendar } from 'lucide-react';

type FilterBarProps = {
  additionalTopFilters?: React.ReactElement;
  includeBenchmark?: boolean;
  includeAggregation?: boolean;
  includeDimension?: boolean;
};

export const FilterBar: React.FC<FilterBarProps> = ({
  additionalTopFilters,
  includeBenchmark,
  includeAggregation,
  includeDimension,
}) => {
  return (
    <FilterAccordion>
      <Flex
        flexDir={{ base: 'column', lg: 'row' }}
        w="100%"
        justifyContent="space-between">
        <Flex flexDir={'row'} wrap="wrap">
          {/* Time Range */}
          <Flex direction="column" mr={3} my={2}>
            <FilterHeading headingText="Time Range" color="content.label" />
            <TimeRangeSelector
              includeTimePeriodButtons
              rightElement={<LockFiltersButton filterType="time range" />}
            />
          </Flex>
          {/* Benchmark Range */}
          {includeBenchmark && (
            <Flex direction="column" mr={3} my={2}>
              <Flex alignItems={'center'}>
                <FilterHeading headingText="Benchmark" color="content.label" />
                <BenchmarkSelectorError />
              </Flex>
              <MenuOpenerButton>
                <ChakraIcon
                  as={Calendar}
                  boxSize={5}
                  mr={2}
                  color="content.title"
                  verticalAlign="middle"
                />
                <BenchmarkSelector />
              </MenuOpenerButton>
            </Flex>
          )}

          {includeAggregation && (
            <Flex direction="column" mr={3} my={2}>
              <AggregationSelector />
            </Flex>
          )}

          {includeDimension && (
            <Flex direction="column" mr={3} my={2}>
              <DimensionSelector />
            </Flex>
          )}

          {/* Campaign Group */}
          <Flex direction="column" alignItems="flex-star" mr={3} my={2}>
            <FilterHeading headingText="Campaign Group" color="content.label" />
            <MenuOpenerButton>
              <CampaignGroupMenu />
            </MenuOpenerButton>
          </Flex>

          {/* Campaigns */}
          <Flex direction="column" alignItems="flex-star" mr={3} my={2}>
            <FilterHeading headingText="Campaigns" color="content.label" />
            <MenuOpenerButton>
              <CampaignsMenu />
              <LockFiltersButton filterType="campaigns" />
            </MenuOpenerButton>
          </Flex>

          {/* Media */}
          <Flex direction="column" alignItems="flex-start" mr={3} my={2}>
            <FilterHeading headingText="Media" color="content.label" />
            <MenuOpenerButton>
              <MediaMenu />
              <LockFiltersButton filterType="media" />
            </MenuOpenerButton>
          </Flex>

          {additionalTopFilters}
        </Flex>

        <Flex alignItems="flex-end" mb={2} mt={{ base: 2, lg: 0 }}>
          <MasterDataDownloadButton />
        </Flex>
      </Flex>

      {/* Clear Filters */}
      <ClearFiltersButton />
    </FilterAccordion>
  );
};
